import { render } from "./chevron-right-icon.svg?vue&type=template&id=2440f8b0"
import script from "./chevron-right-icon.svg?vue&type=script&lang=js"
export * from "./chevron-right-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src844/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__